/* eslint-disable */
import '../vendor/iframeResizer.min';
import "../vendor/owl-carousel/owl.carousel.min.css";
import GetMobileOperatingSystem from "../js/global/mobile-operating-system";

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

let owl_carousel = require('owl.carousel');
window.fn = owl_carousel;
let ellipsis = require('../vendor/jquery-ellipsis/fewlines-min');

var ran = false;
var mobileOS = GetMobileOperatingSystem();

var windowWidth = $(window).width();

var globalAssetPath = '';

function init(assetPath) {
    globalAssetPath = assetPath;
    initOwlCarousel();
    productsList();
    initTruncateText();
    initIFrameResizer(); 
    updateBackgroundImages();
}

function initOwlCarousel() {
    mobileOS = GetMobileOperatingSystem();
    windowWidth = $(window).width();
    var owl = $('.products .owl-carousel');
    
    if (windowWidth <=1024) {
        var owlStage = owl.find('.owl-stage-outer');
        if(owlStage.length === 1) {
            //exit out since owl carousel is already initialized
            return;
        }
        owl.owlCarousel({
          loop:true,
          nav:true,
          dots: false,
          items: 1,
          navText: '',
          autoHeight: true
        });
    }else{
      owl.owlCarousel('destroy');
   } 

   setTimeout(function() {

        var owlnav = $('.owl-nav');

        if(owlnav) {

            owlnav.find('.owl-prev').addClass('lazyload').attr('data-bg', globalAssetPath + '/img/virtual-reality/carousel-left-arrow.png');
            owlnav.find('.owl-next').addClass('lazyload').attr('data-bg', globalAssetPath + '/img/virtual-reality/carousel-right-arrow.png');
        }

        //setPositionOfOwlNav();

    }, 100); 

    
}

function setPositionOfOwlNav() {
    var owlnav = $('.owl-nav');
    if(owlnav) {
        var img = $('.product-items .owl-item.active img');
        console.log(img);
        var heightOfImg = img.height();
        console.log(heightOfImg);
    }
}

function initTruncateText() {

    mobileOS = GetMobileOperatingSystem();
    windowWidth = $(window).width();

    var lines = '';

    if(ran === true) {
        return;
    }

    
    if(mobileOS !== 'unknown') {

        if(windowWidth > 768) {
            lines = 2;
        }
        else {
            lines = 8;
        }

        $('.our-customers .featured-content, .medical-education .featured-content, .media .featured-content').fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': lines,
            'ellipsis': '',
            responsive: true
        });

        
        ran = true;
    }
    else {
        $('.our-customers').addClass('non-os');
    }

}

function initIFrameResizer() {
    //detect Internet Explorer
    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)

     const myIframe = document.querySelector('.form-container iframe');
     if(isIE) {
         //do nothing
     }
     else {
        iFrameResize({
            log:false,
            checkOrigin:false,
            bodyPadding:'0 0 40px 0',
           }, myIframe);
     }
}

function productsList() {
    var products = $('.products');
    var productsList = products.find('.products-list li');
    var productItems = products.find('.product-items li');

    productsList.find('a').on('click', function(e) {
        e.preventDefault();
        var currentIndex = e.target.getAttribute('data-index');
        productsList.each(function() {
            $(this).removeClass('active');
        })
        $(this).parent('li').addClass('active');
        productItems.each(function() {
            $(this).removeClass('active').addClass('non-active');
        })
        productItems[currentIndex].classList.add('active');
        productItems[currentIndex].classList.remove('non-active');

    })
}

function updateBackgroundImages() {
    var elemBG, elemBGName, elemBGStyleName, splitString, endOfUrl, newEndOfUrl = '';
    windowWidth = $(window).width();
    elemBG = $('.featured-header-video-bg');
    elemBG.each(function(index) {
        if($(this).attr('data-bg') !== undefined) {
            elemBGName, splitString, endOfUrl = '';
            elemBGName = $(this).attr('data-bg');
            splitString = elemBGName.split('/');
            endOfUrl = splitString[(splitString.length) - 1];

            if($(this).attr('style') !== undefined) {
                elemBGStyleName = $(this).attr('style');
                splitString = elemBGStyleName.split('/');
                endOfUrl = splitString[(splitString.length) - 1];
                endOfUrl = endOfUrl.replace('");', '');
            }

            if(windowWidth > 1024) {
                if(endOfUrl !== '') {
                    switch (endOfUrl) {
                        case 'quote-bg-mobile.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('-mobile', '');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('-mobile', '');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        case 'header-bg-mobile.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('-mobile', '');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('-mobile', '');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                if(endOfUrl != '') {
                    switch (endOfUrl) {
                        case 'quote-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('quote-bg.jpg', 'quote-bg-mobile.jpg');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('quote-bg.jpg', 'quote-bg-mobile.jpg');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        case 'header-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('header-bg.jpg', 'header-bg-mobile.jpg');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('header-bg.jpg', 'header-bg-mobile.jpg');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    });
}

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        var classes = (e.target.classList);
        if(classes.contains('quote')) {
            if(windowWidth > 1024) {
                bg = bg.replace('-mobile', '');
            }
        }
        e.target.style.backgroundImage = 'url(' + bg + ')';

    }
});

$(window).resize(function() {
    initOwlCarousel();
    initTruncateText();
    updateBackgroundImages();
});

export default init;